export default "__VITE_ASSET__bf18a36c__"